import { create } from '@thoughtspot/logger';
import _ from 'lodash';
const logger = create('chart-to-ts > tml-events');
const validateSetTMLSEventPayload = (eventData) => {
    const payload = eventData.payload;
    if (!_.isString(payload.tmlString)) {
        logger.warn(`tmlString is not a string! tmlString: ${payload.tmlString}`);
        return {
            isValid: false,
            errors: [
                `tmlString is not a string! tmlString: ${payload.tmlString}`,
            ],
        };
    }
    return {
        isValid: true,
    };
};
const getSetTMLStringEventProcessor = (props) => {
    return {
        validateEventPayload: (eventData) => {
            return validateSetTMLSEventPayload(eventData);
        },
        executeEvent: async (eventData) => {
            props.setTMLString(eventData?.payload?.tmlString);
            return Promise.resolve();
        },
    };
};
const getGetTMLStringEventProcessor = (props) => {
    return {
        validateEventPayload: (eventData) => {
            return { isValid: true };
        },
        executeEvent: async (eventData) => {
            const tmlString = await props.getTMLString();
            logger.debug(`GetTMLString response: ${tmlString}`);
            return Promise.resolve({
                tmlString,
            });
        },
    };
};
export { getSetTMLStringEventProcessor, getGetTMLStringEventProcessor };
//# sourceMappingURL=index.js.map